@import "../../../../shared/scss";

:host {
  display: block;
  padding-inline: 10%;

  @include pds-media-query-max("s") {
    padding-inline: p-px-to-rem(27px);
  }

  .models-item {
    max-inline-size: $max-model-width;
    inline-size: 100%;
  }

  button {
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  @include pds-media-query-min("s") {
    margin-block-start: p-px-to-rem(-28px);
  }

  @include pds-media-query-min("xl") {
    margin-block-start: p-px-to-rem(-36px);
  }

  ul {
    padding-block: 0;
    padding-inline: 0;
    display: grid;
    place-items: center;
    gap: $pds-spacing-static-small + $pds-spacing-static-x-small;

    @include pds-media-query-min("s") {
      gap: 1px;
    }

    & li {
      list-style: none;
    }
  }

  .skeleton-headline {
    inline-size: auto;
    block-size: p-px-to-rem(50px);
    background: $pds-theme-light-contrast-low;
    border-radius: 4px;
  }

  .series {
    display: flex;
    justify-content: center;
    inline-size: 100%;
    // calculated to include the 4px focus padding
    margin-block: 0;
    margin-inline: 0;

    phn-nd-menu-item {
      inline-size: 100%;
    }

    .model-area-hidden {
      display: none;
    }

    &:focus-visible {
      outline-color: $pds-theme-light-state-focus;
    }
  }
}
